import React from 'react'
import CodeMirror from '@uiw/react-codemirror'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { ITransactionSetWithSubtype } from 'types/graphqlTypes'
import { SettingsIcon } from 'transfix-icons'
import { formatOptionLabel as formatTransactionSetLabel } from '../hooks/useTransactionSets'

interface ISampleDataContainerProps {
  isLoading: boolean
  onSettingsClick: () => void
  serializedJsonData: string
  transactionSetWithSubtype: ITransactionSetWithSubtype
}

const useStyles = makeStyles(theme => ({
  editor: {
    borderRight: '1px solid',
    '& .cm-content': {
      border: '1px solid',
      borderRight: 'none',
    },
    '& .cm-lineNumbers': {
      minWidth: 33,
    },
    '& .cm-line::selection': {
      backgroundColor: '#d9d9d9 !important',
    },
  },
  column: {
    flex: 5,
  },
  columnSmall: {
    flex: 3,
  },
  columnLarge: {
    flex: 7,
  },
  messageTypeSelect: {
    marginRight: theme.spacing(1),
  },
  runQueryButton: {
    marginRight: theme.spacing(1),
  },
}))

export const SampleDataContainer = ({
  isLoading,
  onSettingsClick,
  serializedJsonData,
  transactionSetWithSubtype,
}: ISampleDataContainerProps) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.column} ${classes.columnSmall}`} marginX={2}>
      <Box
        marginY={1}
        display='flex'
        flexDirection='row'
        flexWrap='wrap'
        justifyContent='space-between'>
        <Typography variant='h3'>Input Data</Typography>
        <Box>
          Transaction Set: <strong>{formatTransactionSetLabel(transactionSetWithSubtype)}</strong>
          <IconButton
            Icon={SettingsIcon}
            color='secondary'
            onClick={onSettingsClick}
            size='large'
          />
        </Box>
      </Box>
      <CodeMirror
        height='40vh'
        width='30vw'
        className={classes.editor}
        value={isLoading ? 'Loading sample JSON...' : serializedJsonData}
        editable={false}
      />
    </Box>
  )
}
